import styled from 'styled-components';
import { GenericContainerCard } from './MobileUtilitiesTopMatch';
import { useNavigate } from 'react-router-dom';
import { TopDecorColor } from '../../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';
import SpaceInfoMatchComponent from './GenericUtilitiesComponents/SpaceInfoMatchComponent';
const ThisWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    
    
    & h1, h2, h3, h4, h5, h6 {
        margin: 0;
        font-size: 10px;
        text-align: center;
        color: white;
    }
`;

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30%;
    height: 100%;
    row-gap: 5px;
    padding: 0 10px;

    & .avatar-wrestler {
        width: 50px;
        height: 50px;
        object-fit: cover;
        object-position: top;
    }

    & .name-wrestler {
        font-weight: 500;
        margin: 0;
        text-transform: uppercase;
        color: white;
        text-align: center;
        // Se supera il height o width va a capo o mette puntini
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }
`;



function MobileSingleTopMatchRender({ matchInfo }) {
    const navigate = useNavigate();

    const navigateToWrestler = (wrestler) => {
        navigate(`/wrestlers/i_${wrestler.id}_d_${wrestler.name}`);
    }

    function renderWrestler(wrestler) {
        return (
            <SpaceWrestler className='space-wrestler'>
                <img 
                    className='avatar-wrestler' 
                    src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} 
                    alt={wrestler.name} 
                    title={wrestler.name}
                    onClick={() => navigateToWrestler(wrestler)}
                />
                <h2 className='name-wrestler'>{wrestler.name}</h2>
            </SpaceWrestler>
        )
    }

    // JSX 
    return (
        <GenericContainerCard className='mobile-single-top-match-render'>
            <TopDecorColor 
                className='top-decor-color' 
                height='10px' 
                borderTopLeftRadius='10px' 
                borderTopRightRadius='10px' 
            />
            <ThisWrapper className='wrapper-single-top-match'>
                {renderWrestler(matchInfo.wrestlers[0])}

                <SpaceInfoMatchComponent matchInfo={matchInfo} />

                {renderWrestler(matchInfo.wrestlers[1])}
            </ThisWrapper>

        </GenericContainerCard>
    )
}

export default MobileSingleTopMatchRender;